import { settings } from './../config';
import { getToken } from './../global/TokenValidator';
import { MxiTask } from './../types/tasks';
import { HangarPlanPackage } from '../types/hangarPlan';

export interface MechanicTaskNote {
    created_date_text: string;
    barcode: string;
    note: string;
    mxi_user_id: string;
}

class HangarPlanApi {
      GetMechanicTaskNotesByBarcodes = async (taskBarcodes: string[]): Promise<{ status: boolean, data: Record<string, MechanicTaskNote[]> }> => {
        return fetch(`${settings.HOST}/HangarPlan/GetMechanicTaskNotesByBarcodes`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'token': await getToken(),
                'apikey': settings.KONG_KEY,
            },
            body: JSON.stringify(taskBarcodes)
        }).then(x => {
            return x.json()
        })
    }
    GetTasksByWorkpackageBarcode = async (woBarcode: string): Promise<{ status: boolean, message: string, data: MxiTask[] }> => {
        return fetch(`${settings.HOST}/HangarPlan/GetTasksByWorkpackageBarcode/${woBarcode}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'token': await getToken(),
                'apikey': settings.KONG_KEY,
            },
        }).then(x => {
            return x.json()
        })
    }

    GetHangarPlanPackages = async (from: Date, to: Date, status: Array<string>, locations: Array<string>, isShopPlan: boolean, workTypes?: Array<string>
        ): Promise<{ status: boolean; message: string; data: HangarPlanPackage[] }> => {
        return fetch(`${settings.HOST}/HangarPlan/GetHangarPlanPackages`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'apikey': settings.KONG_KEY,
                'token': await getToken(),
            },
            body: JSON.stringify({
                "from": from,
                "to": to,
                "status": status,
                "locations": locations,
                "isShopPlan": isShopPlan,
                "workTypes": workTypes
            })
        }).then(x => {
            return x.json()
        })
    }
}
export default new HangarPlanApi();